// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-UDg_","clinicsSelect":"styles_clinicsSelect__3_1hT"};